import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconApi(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M16.4495 9.37866L19.0708 12L16.2277 14.8432L17.6419 16.2574L20.4851 13.4142C21.2661 12.6332 21.2661 11.3669 20.4851 10.5858L17.8637 7.96445L16.4495 9.37866Z"
        fill="currentColor"
      />
      <path
        d="M11.9998 4.92896L9.15663 7.77211L7.74241 6.35789L10.5856 3.51474C11.3666 2.73369 12.6329 2.73369 13.414 3.51474L16.4495 6.55024L15.0353 7.96445L11.9998 4.92896Z"
        fill="currentColor"
      />
      <path
        d="M7.74241 9.18632L6.3282 7.77211L3.5145 10.5858C2.73345 11.3669 2.73345 12.6332 3.5145 13.4142L6.54999 16.4497L7.9642 15.0355L4.92871 12L7.74241 9.18632Z"
        fill="currentColor"
      />
      <path
        d="M16.2277 17.6716L14.8135 16.2574L11.9998 19.0711L9.37842 16.4497L7.9642 17.8639L10.5856 20.4853C11.3666 21.2664 12.6329 21.2664 13.414 20.4853L16.2277 17.6716Z"
        fill="currentColor"
      />
      <path d="M14 12L12 10L10 12L12 14L14 12Z" fill="currentColor" />
    </BaseIcon>
  );
}
